import { QuestionOutlined } from '@ant-design/icons';
import { StyledAvatar, StyledMenu } from '@geosecma/sidebar';
import SubMenu from 'antd/lib/menu/SubMenu';
import { observer } from 'mobx-react';
import { useRootStore } from 'models/rootModel';

//WCAG: Not possible to control ant visiblity with keyboard. https://github.com/ant-design/ant-design/issues/14356

const SelectMunicipality = () => {
  const { municipality } = useRootStore();

  return (
    <StyledMenu theme="dark" mode="vertical">
      <SubMenu
        tabIndex="0"
        popupClassName="municipality-sub-menu"
        key="sub1"
        title={
          <>
            <span className="anticon">
              {municipality.icon ? (
                <StyledAvatar
                  shape="square"
                  src={municipality.icon.content}
                  alt="logo"
                  data-testid="showMunicipalitiesButton"
                />
              ) : (
                <StyledAvatar shape="square" icon={<QuestionOutlined />} data-testid="showMunicipalitiesButton" />
              )}
            </span>
            <span>{municipality.displayName ? municipality.displayName : municipality.tenantId}</span>
          </>
        }
      />
    </StyledMenu>
  );
};

export default observer(SelectMunicipality);
